import React from "react";
import { Link } from "react-router-dom";
import { products } from "../data";
import { message } from "antd";
function ProductDescription(props) {
  const productId = props.match.params.id;
  const productDetails = products.filter((product) => product.productId === productId)[0];
  const addProductToCart = (product) => {
    // dispatch(addToCart(product));
    if (sessionStorage.getItem("cartItems") == null) {
      product.qty = 1;
      sessionStorage.setItem("cartItems", JSON.stringify([product]));
    } else {
      const cartItems = JSON.parse(sessionStorage.getItem("cartItems"));
      const check = cartItems.filter((item) => item.productId == product.productId);
      if (check.length == 0) {
        product.qty = 1;
        sessionStorage.setItem("cartItems", JSON.stringify([...cartItems, product]));
      }
    }
    message.success("Product Successfully added to Cart", [1]);
  };

  const addToWishList = (product) => {
    if (sessionStorage.getItem("wishlistItems") == null) {
      sessionStorage.setItem("wishlistItems", JSON.stringify([product]));
    } else {
      const wishlistItems = JSON.parse(sessionStorage.getItem("wishlistItems"));
      const check = wishlistItems.filter((item) => item.productId == product.productId);
      if (check.length == 0) {
        sessionStorage.setItem("wishlistItems", JSON.stringify([...wishlistItems, product]));
      }
    }
    message.success("Product Successfully added to Wishlist", [1]);
  };
  return (
    <>
      <div className="container">
        <div className="row mt-5">
          <div className="col-lg-4 col-md-5">
            <img src={productDetails.url} style={{ width: "100%", height: "300px", borderRadius: "10px" }} />
          </div>
          <div className="col-lg-8 col-md-7">
            <h2>{productDetails.productName}</h2>
            <h6 style={{ fontWeight: 600 }} className="mt-4">
              Product Description
            </h6>
            <p>{productDetails.description}</p>
            <div className="d-flex justify-content-between mt-3">
              <button className="btn btn-outline-success btn-md" onClick={() => addProductToCart(productDetails)}>
                <i className="fa fa-shopping-bag mr-2"></i> Add to Cart
              </button>
              <button className="btn btn-outline-danger btn-md" onClick={() => addToWishList(productDetails)}>
                <i className="fa fa-heart mr-2"></i>Add to Wishlist
              </button>
            </div>
          </div>
        </div>
        <h5 className="mb-4 text-center mt-5" style={{ fontWeight: "600" }}>
          Related Products
        </h5>
        <div className="row d-flex align-items-center justify-content-center mt-5">
          {products
            .filter((product) => product.category === productDetails.category && product.productId != productDetails.productId)
            .map((product, i) => {
              if (i < 4) {
                return (
                  <div className="col-lg-3 col-md-6 col-sm-6 mb-5 " key={product.productId}>
                    <div className="product-wrapper  text-center">
                      <div className="product-img">
                        <img src={product.url} className="productimage" alt="" />
                        <span className="text-center">
                          <i class="fas fa-dollar-sign" />
                          {product.price}
                        </span>
                        <div className="product-action">
                          <div className="product-action-style">
                            <Link className="wishlist" onClick={() => addToWishList(product)}>
                              <i className="fa fa-heart wishlish" />
                            </Link>
                            <Link className="cart" onClick={() => addProductToCart(product)}>
                              <i className="fa fa-shopping-cart " />
                            </Link>
                          </div>
                        </div>
                      </div>
                      <Link to={`/productdescription/${product.productId}`}>
                        <h5 className="mt-2">{product.productName}</h5>
                      </Link>
                    </div>
                  </div>
                );
              }
            })}
        </div>
      </div>
    </>
  );
}
export default ProductDescription;
